export function safeExternalUrl(url, fallback = 'https://www.facebook.com/robustarchitectureworkshop/') {
  if (!url || typeof url !== 'string') {
    return fallback;
  }

  try {
    const parsed = new URL(url, 'http://localhost');
    const protocol = parsed.protocol.toLowerCase();
    if (protocol === 'http:' || protocol === 'https:') {
      return url;
    }
  } catch (_) {
    return fallback;
  }

  return fallback;
}
